"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalProcessesDiferenceLevelEnum = void 0;
var ApprovalProcessesDiferenceLevelEnum;
(function (ApprovalProcessesDiferenceLevelEnum) {
    ApprovalProcessesDiferenceLevelEnum["STEP"] = "STEP";
    ApprovalProcessesDiferenceLevelEnum["APPROVAL"] = "APPROVAL";
})(ApprovalProcessesDiferenceLevelEnum || (exports.ApprovalProcessesDiferenceLevelEnum = ApprovalProcessesDiferenceLevelEnum = {}));
